import React from "react";
import "./HeroBanner.css";
import { Link } from "react-router-dom";
import bannerImg from "../assets/Green-Banner.png";

export default function HeroBanner() {
  return (
    <section
      className="cm-hero-section"
      style={{ backgroundImage: `url(${bannerImg})` }}
    >
      <div className="cm-hero-overlay">
        {/* LEFT CONTENT */}
        <div className="cm-hero-content">
          <span className="cm-hero-subtitle">CM GROUP</span>

          <h1 className="cm-hero-title-1">
            150 MW Strong: <br />
Delivering Reliable, 
Sustainable Power. 
          </h1>

          <div className="cm-hero-buttons">
            <Link to="/green-energy/about" className="cm-hero-btn-primary">
    👍 Discover more
  </Link>

  <Link to="/green-energy/services" className="cm-hero-btn-secondary">
    👁 View services
  </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
